<div class="container dev-container">

    <!-- Heading -->
    <div class="row">

        <div class="col"
                align="left">
            <h1 class="blue-heading">
            Dev Page
            </h1>
        </div>

        <div class="col" align="right">
            <app-menu> </app-menu>
        </div>

    </div>

    <div class="row">
        <h6 class="descriptive-text"
            style="font-size: 14px;">
         This page is only to be used for development and testing purposes.
         It should not be accessible in a production build!
        </h6>
    </div>

    <!-- Sync data -->
    <div class="row">
        <h6 class="descriptive-text"
            style="font-weight: bold;">
         Data Syncing
        </h6>
    </div>

    <div class="row">
        <h6 class="descriptive-text">
         Button performs a replicate() with the Common Couch DB
        </h6>
    </div>
 
    <div class="row" style="padding-left: 10px;">
        <div style="text-align: center">
            <button mat-raised-button
                    class="red-button"
                    type="button"
                    (click)="updateData()">
            <span>
                Sync Data
            </span>
            </button>
        </div>
    </div>

    <!-- Email Service -->
    <div class="row">
        <h6 class="descriptive-text"
            style="font-weight: bold;">
        Email Service
        </h6>
    </div>

    <div class="row">
        <h6 class="descriptive-text">
         Button invokes the sendEmail() method in the email service.
        </h6>
    </div>
 
    <div class="row" style="padding-left: 10px;">
        <div style="text-align: center">
            <button mat-raised-button
                    class="red-button"
                    type="button"
                    (click)="sendTestEmail()">
            <span>
                Test Email
            </span>
            </button>
        </div>
    </div>

    <!-- Test Fishery Notice -->

    <div class="row">
        <h6 class="descriptive-text"
            style="font-weight: bold;">
        Test Fishery Notice Formatting
        </h6>
    </div>

    <div class="descriptive-text"
        [innerHTML]="noticeHTML">
    </div>

</div>
